import { styled } from '@mui/system'

export const ChatBox = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0 10px 10px 10px;
  border-left: none;
  border-right: none;
  background-color: white;
  border-radius: 8px 8px 0 0;
  border-top: 1px solid
    ${(props) => props.theme.palette['$color-border-primary']};
  flex-grow: 1;

  .str-chat__channel {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .str-chat__ul {
    padding: 0;
  }
  .str-chat__main-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .str-chat__container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .str-chat__main-panel-inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
    img {
      visibility: hidden;
    }
  }
  .str-chat__virtual-list {
    width: 100%;
    flex-grow: 1;
  }
  .str-chat__li--top {
    img {
      visibility: visible;
    }
    .msgts {
      display: none;
    }
  }
  .str-chat__li--middle {
    .msgts {
      display: none;
    }
  }
  .str-chat__li--single {
    img {
      visibility: visible;
    }
  }
  .str-chat__message-metadata {
  }
  .str-chat__message-list-scroll {
    overflow: hidden overlay !important;
    /* overscroll-behavior: contain; */
    margin-right: -4px;
    :hover {
      margin-right: -12px;
    }

    /* width */
    :hover::-webkit-scrollbar {
      width: 8px;
      border-radius: 8px;
    }
    ::-webkit-scrollbar {
      width: 0px;
      border-radius: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f4f5;
      border-radius: 8px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #ced2db;
      border-radius: 8px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #a9b0bf;
      border-radius: 8px;
    }
  }

  .str-chat__empty-channel {
    display: none;
  }

  .str-chat__list-notifications {
    display: none;
  }

  .str-chat__unread-messages-separator {
    display: none;
  }
`
